import Button from "./components/ui/configurator/Button";

const WarningScreen = (props) => {
    return(
      <div className="warning-screen">
          <div className="warning">
          <p>Please ensure four walls and at least one door have been selected to proceed. For store designs incorporating an open side please get in touch with our team to discuss bespoke options.</p>
            <br/>
            <Button label={"OK"} confirm={true} primary={true} onClick={props.onClick}/>
          </div>
      </div>
    )
  }

  export default WarningScreen;